<template>
  <div class="order-list">
    <table class="order-list-table" cellspacing="1" cellpadding="0">
      <tr class="table-header">
        <th>订单编号</th>
        <th>订单状态</th>
        <th>产品名称</th>
        <th>所属银行</th>
        <th>下单时间</th>
        <th>操作</th>
      </tr>
      <tbody>
        <td class="no-data" colspan="6" v-if="!totalCount">
          暂无数据
        </td>
        <template v-else>
          <tr v-for="item in orderList" :key="item.id">
            <td>{{ item.applyNo || '-' }}</td>
            <td>{{ item.applyStatus || '-' }}</td>
            <td>{{ item.name || '-' }}</td>
            <td>{{ item.bankName || '-' }}</td>
            <td>{{ item.submitTime ? item.submitTime.slice(0, 10) : '-' }}</td>
            <td>
              <button class="operate-btn" @click="onClickDetail(item.id)">查看详情</button>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div class="paging-block">
      <el-pagination
        v-if="totalCount"
        :total="totalCount"
        background
        layout="prev, pager, next"
        @current-change="onChangePage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getURLSearchParams } from '@/utils/tool'
import { getZscqOrderList } from '@/api/zscq'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      orderList: [
        { id: 1, name: 'zscq' },
        { id: 2, name: 'zscq' },
        { id: 3, name: 'zscq' },
        { id: 4, name: 'zscq' },
        { id: 5, name: 'zscq' }
      ],
      pagingPayload: {
        pageNo: 1,
        pageSize: 10
      },
      totalCount: 0
    }
  },
  mounted() {
    this.getssotickentFromUrl()
    this.getProductListCondition()
    this.getOrderList()
  },
  methods: {
    getOrderList() {
      const curParams = { ...this.pagingPayload }
      getZscqOrderList(curParams).then(res => {
        if (res.data.code !== 0) return
        this.orderList = res.data.data.result || []
        this.totalCount = +res.data.data.totalCount
      })
    },
    onChangePage(pageNo) {
      this.pagingPayload.pageNo = pageNo
      this.getOrderList()
    },
    onClickDetail(id) {
      this.$router.push({ name: 'zscqOrderDetail', query: { id } })
    },
    getssotickentFromUrl() {
      const ssotickent = getURLSearchParams('ssotickent')
      if (!ssotickent) return
      sessionStorage.setItem('ssotickent', ssotickent)
    },
    ...mapActions('product', ['getProductCondition', 'getProductListCondition'])
  }
}
</script>

<style lang="scss" scoped>
.order-list {
  width: 100%;

  .order-list-table {
    width: 100%;
    height: 100%;
    background: #e6e6e6;

    .table-header {
      height: 46px;
      padding: 9px 15px;
      background: #eee;
    }

    th {
      color: #333;
    }

    td {
      height: 50px;
      padding: 5px 15px;
      white-space: pre-wrap;
      background: #fff;
    }

    .no-data {
      text-align: center;
    }
  }

  .operate-btn {
    width: fit-content;
    padding: 0 15px;
    height: 38px;
    border: 0;
    border-radius: 5px;
    color: #fff;
    background: #187ce3;
    outline: none;
    cursor: pointer;

    &:active {
      background: rgba(#187ce3, 0.85);
    }
  }

  .paging-block {
    margin-top: 20px;

    /deep/ .number.active {
      background-color: #187ce3 !important;
    }
  }
}
</style>
